import { render, staticRenderFns } from "./KsFilterBar.vue?vue&type=template&id=faf231c0"
import script from "./KsFilterBar.vue?vue&type=script&lang=js"
export * from "./KsFilterBar.vue?vue&type=script&lang=js"
import style0 from "./KsFilterBar.vue?vue&type=style&index=0&id=faf231c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports